<template>
  <div>
    <a-row :gutter="20">
      <a-col :md="14" :xl="18" class="content_q">
        <div>
          <!-- {{ index > -1 ? topicsData[index].answer : "" }} -->
          <div class="header">
            <div class="header_name">
              <div class="header_name_blue"></div>
              <div>
                {{
                  index > -1
                    ? topicsData[index].type == 1
                      ? "单选题"
                      : topicsData[index].type == 2
                      ? "判断题"
                      : topicsData[index].type == 3
                      ? "多选题"
                      : ""
                    : ""
                }}: {{ index + 1 }}/{{ topicsData.length }}
              </div>
            </div>
            <div class="ms">{{ timeout_ }} <span>s</span></div>
          </div>
          <div class="question">
            {{ index > -1 ? topicsData[index].question : "" }}
          </div>
          <div class="options">
            <!-- <a-row :gutter="[30, 30]">
              <a-col :md="24" :lg="12" v-for="v in options" :key="v.label"> -->
            <div class="optionCol" v-for="v in options" :key="v.label">
              <div class="option">
                <div class="op">{{ v.label }}</div>
                <div class="txt">
                  {{ v.value }}
                </div>
              </div>
            </div>
            <!-- </a-col>
            </a-row> -->
          </div>
        </div>
        <div class="msg">
          温馨提示：请在答题器上面选择要选择的 答案，并按确认键提交，谢谢配合
        </div>
      </a-col>
      <a-col :md="10" :xl="6" class="content_data">
        <div class="header_right">
          <a-row
            type="flex"
            align="middle"
            justify="space-between"
            style="height: 100%"
          >
            <a-col>
              <div class="header_right_name">
                <div class="header_right_name_blue"></div>
                答题详情
              </div>
            </a-col>
            <a-col class="annum">
              未答/已答：{{
                index > -1
                  ? controlRot.filter((v) => !v.result[index].myanswer).length
                  : 0
              }}/{{
                index > -1
                  ? controlRot.filter((v) => !!v.result[index].myanswer).length
                  : 0
              }}
            </a-col>
          </a-row>
        </div>
        <div class="person_list">
          <a-row :gutter="[16, 16]">
            <a-col
              :lg="12"
              :xl="12"
              :xxl="8"
              v-for="(v, i) in controlRot"
              :key="i"
            >
              <div
                class="person_item"
                :class="{
                  person_item_active: index > -1 && !!v.result[index].myanswer,
                }"
              >
                <!-- {{ index > -1 ? v.score : "" }} -->
                {{ v.iKeyID < 0 ? "0" + v.iKeyID : v.iKeyID }}
                {{ v.name ? v.name : "" }}
                <!-- {{ index > -1 ? v.result[index].myanswer : "" }} -->
              </div>
            </a-col>
          </a-row>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  props: {
    //已经读取的人员
    controlRot: {
      type: Array,
      default() {
        return [];
      },
    },
    //题目
    topicsData: {
      type: Array,
      default() {
        return [];
      },
    },
    //当前在第几题
    index: {
      type: Number,
      default: -1,
    },
    //配置一题的答题时间
    timeout: {
      type: [String, Number],
      default: 30,
    },
  },
  computed: {
    options() {
      if (this.index < 0) return [];
      const op = [
        { label: "A", value: this.topicsData[this.index].q1 },
        { label: "B", value: this.topicsData[this.index].q2 },
        { label: "C", value: this.topicsData[this.index].q3 },
        { label: "D", value: this.topicsData[this.index].q4 },
        { label: "E", value: this.topicsData[this.index].q5 },
        { label: "F", value: this.topicsData[this.index].q6 },
        { label: "G", value: this.topicsData[this.index].q7 },
        { label: "H", value: this.topicsData[this.index].q8 },
        { label: "I", value: this.topicsData[this.index].q9 },
      ];
      let ok = [];
      for (let i = 0; i < op.length; i++) {
        if (!!op[i].value) ok.push(op[i]);
      }
      return ok;
    },
    //已答人数
    okperson() {
      if (this.index < 0) return 0;
      let ok = 0;
      for (let i = 0; i < this.controlRot.length; i++) {
        console.log(this.controlRot[i].result[this.index]);
        if (!!this.controlRot[i].result[this.index].myanswer) {
          ok++;
        }
      }
      return ok;
    },
  },
  data() {
    return {
      timeout_: "", //实际的超时时间
      timeout_timer: null,
    };
  },
  methods: {
    //初始化一道题
    init() {
      if (this.index == -1) {
        this.$emit("startExam");
      }
      this.timeout_ = parseInt(this.timeout); //超时时间
      this.timeout_timer = setInterval(() => {
        this.timeout_ -= 1;
        //时间到，走结束逻辑
        if (this.timeout_ == 0) {
          clearInterval(this.timeout_timer);
          this.$emit("overonce"); //结束一次
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  height: 60px;
  background: #fafbff;
  border-radius: 4px 0px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 40px;
  padding-right: 30px;
  box-sizing: border-box;
}
.header_name {
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #0073ff;

  .header_name_blue {
    width: 4px;
    height: 24px;
    background: #0073ff;
    margin-right: 10px;
  }
}
.ms {
  min-width: 80px;
  padding: 0 18px;
  height: 42px;
  background: #0073ff;
  border-radius: 6px;
  font-size: 30px;
  color: #fff;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  span {
    font-size: 20px;
    margin-bottom: 5px;
    margin-left: 5px;
  }
}

.question {
  min-height: 300px;
  padding: 30px;
  box-sizing: border-box;
  font-size: 22px;
  font-weight: 400;
  line-height: 30px;
  color: #011733;
  border-bottom: 1px solid #edf1f4;
}
.options {
  padding: 20px 15px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  // border: 1px solid red;
  .optionCol {
    padding: 20px 15px;
    box-sizing: border-box;
    width: 50%;
    height: auto;
    .option {
      padding: 34px 30px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      background: #fafbff;
      border: 1px solid #f5f6fa;
      border-radius: 4px;
      height: 100%;
      .op {
        font-size: 18px;
        color: #3c4048;
        width: 10%;
        text-align: left;
        // border: 1px solid red;
      }
      .txt {
        width: 90%;
        font-size: 22px;
        font-weight: 400;
        line-height: 30px;
        color: #011733;
        // border: 1px solid red;
        text-align: center;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .optionCol {
    width: 100% !important;
  }
}
.msg {
  font-size: 16px;
  line-height: 30px;
  color: #ea1313;
  padding-left: 30px;
  box-sizing: border-box;
}

.content_q,
.content_data {
  // border: 1px solid red;
  height: calc(100vh - 260px);
  overflow-y: auto;
}
.content_q {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.content_data {
  background: #fafbff;
  border: 1px solid #f5f6fa;
}

.header_right {
  height: 60px;
  padding: 0px 10px;
  box-sizing: border-box;
  // border: 1px solid red;
  .header_right_name {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #011733;
    .header_right_name_blue {
      width: 6px;
      height: 30px;
      background: #0073ff;
      margin-right: 20px;
    }
  }
}
.annum {
  font-size: 14px;
  font-weight: 400;
  color: #0073ff;
  text-align: center;
}
.person_list {
  padding: 30px 10px;
  box-sizing: border-box;
  height: calc(100% - 60px);
  // border: 1px solid blue;
  overflow: auto;
  .person_item {
    height: 42px;
    background: #f5f6fa;
    border-radius: 4px;
    text-align: center;
    line-height: 42px;
    font-size: 14px;
    font-weight: 400;
    color: #9ba2ab;
  }
  .person_item_active {
    background: #0073ff;
    color: #ffffff;
  }
}
</style>